import { render, staticRenderFns } from "./LeaveSummaries.vue?vue&type=template&id=e4b56188"
import script from "./LeaveSummaries.vue?vue&type=script&lang=js"
export * from "./LeaveSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports